module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2Cw0Gb/tc-custom/9781571205247.jpg?1705261434234",
      "alt": "This image is the cover for the book From Fiber to Fabric"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("From Fiber to Fabric\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The quilter’s definitive resource on the selection, use, and care of today’s textiles. ")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This book from an internationally known quiltmaker and teacher is a thorough reference filled with fabric facts. Along with easy-to-understand directions for testing fiber content, thread count, colorfastness, lightfastness, washfastness, and shrinkage, you’ll find:"), _c('br'), _vm._v("   Information on the effects of water and detergents on different fabrics and dyesThread compatibility and batting selection chartsRecommendations for storing quilts  "), _c('br'), _vm._v(" With a better understanding of how textiles are made, what to consider when buying them, and how to care for them once you bring them home, you will have much more enjoyment and less stress as you create your wonderful quilts.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Harriet Hargrave\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Harriet Hargrave Bio: Harriet Hargrave is a world-renowned quilter, teacher, and best-selling author. She is responsible for myriad products pertaining to machine quilting, from batting to fabric. In 1981, she opened the hugely successful quilt shop, Harriet’s Treadle Arts, in Denver, Colorado. harriethargrave.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0